export const DOWNLOAD_FILES_AS_ZIP_SUCCESS = 'DOWNLOAD_FILES_AS_ZIP_SUCCESS';

export const downloadFilesAsZipSuccess = () => ({
    type: DOWNLOAD_FILES_AS_ZIP_SUCCESS,
});
